var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("network-button-window", {
    attrs: {
      "window-name": _vm.$t("NetworkStartingPoint"),
      "parent-toggle-window": _vm.windowOpen,
      "list-missing-permissions": _vm.listMissingPermissions,
      "is-fixed": _vm.isFixed
    },
    scopedSlots: _vm._u([
      {
        key: "buttonIcon",
        fn: function() {
          return [_c("NetworkIcon", { staticClass: "network-icon" })]
        },
        proxy: true
      },
      {
        key: "refreshButton",
        fn: function() {
          return [
            _c(
              "v-btn",
              {
                staticClass: "mr-0",
                staticStyle: { height: "20px", width: "20px" },
                attrs: {
                  "x-small": "",
                  fab: "",
                  text: "",
                  color: "accent",
                  loading: _vm.refreshingOptions
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.getOptions.apply(null, arguments)
                  }
                }
              },
              [_c("v-icon", { attrs: { size: "15" } }, [_vm._v("refresh")])],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "windowContent",
        fn: function() {
          return [
            _vm.isAdmin
              ? _c("treeselect", {
                  staticClass: "starting-point-select",
                  class: {
                    "network-starting-point-highlighted-select":
                      _vm.isWorkspaceUndefined &&
                      _vm.workspace.selectHighlighted &&
                      _vm.listMissingPermissions.length === 0
                  },
                  attrs: {
                    options: _vm.workspace.options,
                    normalizer: _vm.workspaceOptionsNormalizer,
                    "disable-branch-nodes": true,
                    "show-count": true,
                    clearable: false,
                    placeholder: _vm.$tc("Workspace", 1),
                    disabled: _vm.interactionsDisabled,
                    disableFuzzyMatching: ""
                  },
                  model: {
                    value: _vm.workspace.uuid,
                    callback: function($$v) {
                      _vm.$set(_vm.workspace, "uuid", $$v)
                    },
                    expression: "workspace.uuid"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("treeselect", {
              staticClass: "starting-point-select",
              class: {
                "network-starting-point-highlighted-select":
                  !_vm.isWorkspaceUndefined &&
                  _vm.startingPoint.selectHighlighted &&
                  _vm.listMissingPermissions.length === 0
              },
              attrs: {
                options: _vm.startingPoint.options,
                "disable-branch-nodes": true,
                "show-count": true,
                placeholder: _vm.$tc("TechnicalLocal", 1),
                disabled: _vm.isWorkspaceUndefined || _vm.interactionsDisabled,
                disableFuzzyMatching: ""
              },
              model: {
                value: _vm.startingPoint.uuid,
                callback: function($$v) {
                  _vm.$set(_vm.startingPoint, "uuid", $$v)
                },
                expression: "startingPoint.uuid"
              }
            }),
            _vm._v(" "),
            _c("treeselect", {
              staticClass: "starting-point-select",
              class: {
                "network-starting-point-highlighted-select":
                  !_vm.isWorkspaceUndefined &&
                  _vm.closures.selectHighlighted &&
                  _vm.listMissingPermissions.length === 0
              },
              attrs: {
                options: _vm.closures.options,
                "disable-branch-nodes": false,
                "show-count": true,
                placeholder: _vm.$tc("Closures", 1),
                disabled:
                  _vm.isWorkspaceUndefined ||
                  _vm.closureSelectionDisabled ||
                  !_vm.closureDisabled,
                disableFuzzyMatching: ""
              },
              model: {
                value: _vm.closures.uuid,
                callback: function($$v) {
                  _vm.$set(_vm.closures, "uuid", $$v)
                },
                expression: "closures.uuid"
              }
            }),
            _vm._v(" "),
            _c("home-window-button", {
              attrs: { label: _vm.$t("Submit"), disabled: _vm.submitDisabled },
              on: { buttonClick: _vm.submit }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61510af4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61510af4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/StartingPoint/StartingPoint.vue
// module id = null
// module chunks = 